import React from 'react'


import { Link, NavLink, useHistory } from 'react-router-dom'

import Drawer from './Drawer';

export const MenuScreen = () => {
    return (
        <div className="menu__menu">
            <div className="menu__logo">

<Drawer/>

                 <h3>Emyto</h3>
             </div>

             <div className="menu__sections">
                 
                <NavLink 
                        activeClassName="menu__active"
                        className="menu__item" 
                        exact
                        to="/"
                    >
                        Inicio
                    </NavLink>
                    <NavLink 
                        activeClassName="menu__active"
                        className="menu__item" 
                        exact
                        to="/HowWorks"
                    >
                        ¿Cómo Funciona?
                    </NavLink>

                    <NavLink 
                        activeClassName="menu__active"
                        className="menu__item" 
                        exact
                        to="/StepsToFollow"
                    >
                        Pasos a seguir
                    </NavLink>


                    <NavLink 
                        activeClassName="menu__active"
                        className="menu__item" 
                        exact
                        to="/auth"
                    >
                       Dapp
                    </NavLink>


                    <NavLink 
                        activeClassName="menu__active"
                        className="menu__item" 
                        exact
                        to="/Contact"
                    >
                        Contacto
                    </NavLink>
             </div>
            
        </div>
    )
}
